module.exports = __webpack_public_path__ + "img/eg.2ea321dd.svg";